import PocketBase from "pocketbase";
import { env } from "@/lib/core/env";
import type { TypedPocketBase } from "./pb-types";
import { localizeErrorBody } from "./server-errors";

/** Single PocketBase client for the whole app. Auth state persists in localStorage. */
export const pb = new PocketBase(env.pocketbaseUrl) as TypedPocketBase;

// React StrictMode + React Query fire duplicate requests; don't let the SDK cancel them.
pb.autoCancellation(false);

// Error responses speak our words in the UI language, never PocketBase's (lib/core/server-errors.ts).
pb.afterSend = (response, data) => (response.ok ? data : localizeErrorBody(response.status, data));
